import { gql } from '@apollo/client';
import { PenaltySource } from '../../../penaltyCenter/graphql/types';

export const GENERATE_APPEAL_REVIEW_REPORT = gql`
  mutation GenerateAppealReviewReport(
    $warehouseId: Long
    $dspId: Long
    $trackingNumber: String
    $statuses: [Int!]
    $creationTimeRange: TimeRangeTypeInput
    $penaltySources: [PenaltySourceType!]
    $language: String
    $timezone: String
  ) {
    generateAppealReviewReport(
      warehouseId: $warehouseId
      dspId: $dspId
      trackingNumber: $trackingNumber
      statuses: $statuses
      creationTimeRange: $creationTimeRange
      penaltySources: $penaltySources
      language: $language
      timezone: $timezone
    ) {
      success
      errorCode
      fileName
    }
  }
`;

export interface GenerateAppealReviewReportVariables {
  warehouseId?: number | null;
  dspId?: number | null;
  trackingNumber?: string | null;
  statuses?: number[] | null;
  creationTimeRange?: { start: string; end: string } | null;
  penaltySources?: PenaltySource[] | null;
  language?: string | null;
  timezone?: string | null;
}

export interface GenerateAppealReviewReportResponse {
  generateAppealReviewReport: {
    success: boolean;
    errorCode?: string | null;
    fileName?: string | null;
  };
}
